export const LIST = 'list';
export const DETAIL = 'detail';
export const STATE = 'state';
export const MONITOR = 'monitor';
export const ROLLUP = 'rollup';
export const ADMINISTRATION = 'administration';
export const LINKING = 'linking';
export const COUNT = 'count';
